import { Outlet, useOutletContext } from "react-router-dom";
import { Alert, Box } from "@dealer-center/core-components";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { Locale } from "@dealer-center/ddc-core-utils";

// Labels are loaded once at module scope by the lib entry point (`index.ts`), per
// Configuration Principle VI — not here in a render body.

export const Configuration = () => {
  const { "ddc-configuration-access": hasPageAccess } = useCC9Flags();

  /*
   * Read the parent's outlet context so it can be handed straight back down.
   *
   * This is NOT redundant. `<Outlet />` compiles to `useOutlet(props.context)`, which *always* wraps
   * the child in `<OutletContext.Provider value={context}>` — so a bare `<Outlet />` publishes
   * `undefined` and **shadows** whatever the parent provided. `PagesControlcenterApp` renders
   * `<Outlet context={{ ccUserInfo, userEntity }} />`, and this shell sits between it and `MyInfo`,
   * so without the pass-through `useMyInfoSubject` finds no context and throws for every visitor.
   * Anchored by `routes.spec.tsx` — the seam is invisible to a unit test of either component alone.
   */
  const outletContext = useOutletContext<unknown>();

  // `=== false` on purpose: flags are `undefined` until the LD client initializes.
  if (hasPageAccess === false) {
    return (
      <Alert sx={{ marginBottom: "16px" }} type="error">
        {String(Locale.getText("NO_ACCESS"))}
      </Alert>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        minHeight: 0
      }}
    >
      <Outlet context={outletContext} />
    </Box>
  );
};
